"use strict";

import api from "vwa/api";

function getWellFormatedPosition(position) {
	if (!position)
		return null;
	
	if (position.type !== undefined && position.type == "Point" && position.coordinates) {
		return position;
	}
	else if (position.lat !== undefined && position.lng !== undefined) {
		return {
			type: "Point",
			coordinates: [position.lng, position.lat]
		};
	}
	else if (position instanceof google.maps.LatLng) {
		return {
			type: "Point",
			coordinates: [position.lng(), position.lat()]
		};
	}
	else return null;
}

export default async function storeAddress(position, address) {
	
	if (!position || !address)
		return;
	
	await api.post('addresses', {
		addresses: [{
			position: getWellFormatedPosition(position),
			address: address
		}]
	});
}


// WEBPACK FOOTER //
// ./src/api/storeAddress.js